import { getFormAnswers, deleteFormAnswer } from '@bforms-web/common';

import FormsList, { FormAnswersListProps } from '../../components/Form/GSK/PatientSpirometry/List';

const dispatchers: Pick<FormAnswersListProps, 'getFormAnswers' | 'deleteFormAnswer'> = {
  getFormAnswers,
  deleteFormAnswer,
};

export default function FormListComposer(): JSX.Element {
  return <FormsList {...dispatchers} />;
}
